/**
 * SAAS-PORTAL — "Adicionar dispositivo" (FASE 5, portal do cliente).
 *
 * O cliente cola o CÓDIGO seguro de claim (fornecido pela equipe/instalador) e
 * o backend vincula o device ao seu tenant. NUNCA se reivindica por device_id
 * puro — o segredo é o código. Sucesso/erro vêm do backend (403 protegido, 409
 * já vinculado/expirado/usado, 404 código inválido).
 */
import { useState } from "react";
import NavIcon from "../nav/NavIcon.jsx";
import { claimDevice } from "../lib/api.js";

export default function ClaimDevicePage({ onOpenDetail }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  async function handleClaim(e) {
    e.preventDefault();
    setError(null);
    setResult(null);
    if (!code.trim()) {
      setError("Cole o código de vínculo do dispositivo.");
      return;
    }
    setBusy(true);
    try {
      const out = await claimDevice(code.trim());
      setResult(out);
      setCode("");
    } catch (err) {
      setError(err?.message || "Não foi possível vincular o dispositivo.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <header>
        <div className="section-label mb-2">Portal da empresa</div>
        <h1 className="text-3xl font-semibold tracking-tight text-noc-text">Adicionar dispositivo</h1>
        <p className="text-sm text-noc-muted mt-1 max-w-xl">
          Use o código de vínculo seguro fornecido pela equipe. Ele é de uso único e possui validade.
        </p>
      </header>

      <form onSubmit={handleClaim} className="glass-card p-6 space-y-5">
        <div className="h-12 w-12 rounded-2xl bg-noc-accent/10 text-noc-accent inline-flex items-center justify-center">
          <NavIcon name="qr" size={22} />
        </div>
        <div className="space-y-1">
          <label className="label">Código de vínculo</label>
          <input
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="w-full h-12 px-4 rounded-xl bg-noc-bg/60 border border-noc-border text-noc-text focus:border-noc-accent/60 outline-none font-mono text-sm"
            placeholder="cole o código aqui"
            spellCheck={false}
            autoComplete="off"
          />
        </div>

        {error && (
          <div className="flex items-center gap-2 text-sm text-noc-err bg-noc-err/10 border border-noc-err/30 rounded-lg px-3 py-2">
            <span className="led-err" />
            {error}
          </div>
        )}

        {result && (
          <div className="text-sm text-noc-ok bg-noc-ok/10 border border-noc-ok/30 rounded-lg px-3 py-2 space-y-2">
            <div>✅ Dispositivo <span className="font-mono">{result.device_id}</span> vinculado à sua empresa.</div>
            {onOpenDetail && (
              <button type="button" onClick={() => onOpenDetail(result.device_id)}
                className="btn-ghost h-8 px-3 text-xs">
                Abrir dispositivo
              </button>
            )}
          </div>
        )}

        <button type="submit" disabled={busy} className="btn-primary w-full h-11">
          {busy ? "Vinculando…" : "Vincular dispositivo"}
        </button>
      </form>
    </div>
  );
}
